var _line, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.521068,
    y1: 37.9828,
    x2: 61.1603,
    y2: 37.9828,
    stroke: "#828282",
    strokeWidth: 1.04214,
    strokeLinecap: "round",
    strokeDasharray: "2.08 2.08"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97754 36.6073C9.0601 23.2207 12.0371 -2.31667 15.2848 2.62605C15.2848 2.42008 15.6096 2.74955 16.9087 5.71519C17.1793 5.50924 18.5325 11.6465 21.7802 37.8429C22.3215 42.9916 23.5664 54.1539 24.216 57.6138C24.7572 58.2316 26.1646 57.7373 27.4636 50.8175C27.7343 48.3462 28.6003 43.2799 29.8994 42.7856C30.7113 42.1678 33.1471 44.2684 36.3948 57.6138C36.936 59.0554 39.4801 57.2431 45.3259 38.4607C45.8672 36.1954 47.924 32.6531 51.8213 36.6073C53.4451 38.5605 58.1542 41.6657 64.0001 38.4607",
    stroke: "#66FCF1",
    strokeWidth: 2.1446,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartC);
export default __webpack_public_path__ + "static/media/chartC.763c9ec2de107cad3d803c6ecd27e466.svg";
export { ForwardRef as ReactComponent };